import { motion } from "framer-motion";
import { ArrowRight, Check } from "lucide-react";
import { FadeUp, Chapter, EASE } from "@/components/Reveal";
import { SERVICES } from "@/data/content";

const slug = (t) => t.toLowerCase().replace(/[^a-z]+/g, "-");

export default function Services({ onConsult }) {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="border-t border-white/5 py-28 lg:py-36"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <Chapter num="02" label="Services" />
        <div className="mt-8 flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
          <FadeUp delay={0.1}>
            <h2 className="max-w-xl font-serif text-4xl leading-tight tracking-[-0.02em] text-cream sm:text-5xl">
              Everything Your Brand Needs to{" "}
              <span className="italic text-gold">Grow.</span>
            </h2>
          </FadeUp>
          <FadeUp delay={0.2}>
            <p className="max-w-sm text-sm leading-relaxed text-cream/50">
              Six core disciplines, one integrated strategy — tailored to your
              business, measured by results.
            </p>
          </FadeUp>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s, i) => (
            <motion.article
              key={s.title}
              data-testid={`service-card-${slug(s.title)}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: (i % 3) * 0.12, ease: EASE }}
              whileHover={{ y: -6 }}
              className="group flex flex-col rounded-2xl border border-white/10 bg-white/[0.02] p-8 transition-colors duration-500 hover:border-gold/40 hover:shadow-[0_8px_40px_rgba(201,163,78,0.1)]"
            >
              <div className="mb-6 inline-flex h-12 w-12 items-center justify-center rounded-xl border border-gold/30 bg-gold/5 text-gold transition-colors duration-500 group-hover:bg-gold group-hover:text-noir">
                <s.icon className="h-5 w-5" />
              </div>
              <h3 className="font-serif text-2xl text-cream">{s.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-cream/50">
                {s.description}
              </p>
              <ul className="mt-6 space-y-2.5">
                {s.features.map((f) => (
                  <li
                    key={f}
                    className="flex items-center gap-2.5 text-sm text-cream/65"
                  >
                    <Check className="h-3.5 w-3.5 shrink-0 text-gold" />
                    {f}
                  </li>
                ))}
              </ul>
              <button
                data-testid={`service-learn-more-${slug(s.title)}`}
                onClick={() => onConsult(s.title)}
                className="mt-8 inline-flex items-center gap-2 self-start text-sm font-semibold tracking-wide text-gold"
              >
                Learn More
                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" />
              </button>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
